<script setup>
/**
 * Este componente muestra los días de la semana (de lunes a domingo)
 * y permite al usuario seleccionar.
 */
import { computed, inject, ref } from 'vue';

const $I18n = inject('I18n');

const props = defineProps({
  modelValue: { type: Array, required: true },
  disabled: { type: Boolean, default: false },
  diasSemana: { type: Array, default: () => [1, 2, 3, 4, 5, 6, 0] },
});

const emits = defineEmits(['update:modelValue']);

const diasSemanaDisplay = computed(() => {
  const nombres = $I18n.t('date.abbr_day_names');
  return props.diasSemana.map((pos) => ({ value: pos, label: nombres[pos] }));
});

function cambiaCheck(dia, event) {
  const copia = props.modelValue.slice();
  const { checked } = event.currentTarget;

  if (checked) {
    if (!copia.includes(dia.value)) {
      copia.push(dia.value);
    }
  } else if (copia.includes(dia.value)) {
    const index = copia.indexOf(dia.value);
    if (index >= 0) {
      copia.splice(index, 1);
    }
  }

  emits('update:modelValue', copia.sort());
}
</script>
<template>
  <div class="dias-semana">
    <div class="pretty_checkbox">
      <div
        v-for="dia in diasSemanaDisplay"
        :key="dia.value"
        class="check-dia pretty p-icon"
      >
        <input
          class="pretty_checkbox"
          type="checkbox"
          :value="dia.value"
          :checked="modelValue.includes(dia.value)"
          :disabled="disabled"
          @change="cambiaCheck(dia, $event)"
        />
        <div class="state p-cifra">
          <i class="icon fa fa-check"></i>
          <label class="pretty_checkbox control-label">
            {{ dia.label }}
          </label>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  .dias-semana {
    display: flex;
    flex-flow: row;
  }

  .check-dia {
    padding-right: 8px;
  }
</style>
